import React from 'react';
import { PhoneCall, ClipboardList, Sparkles } from 'lucide-react';
export function HowItWorks() {
  const steps = [{
    number: '1',
    icon: <PhoneCall className="w-8 h-8" data-id="element-98" />,
    title: 'Request Your Free Visit',
    description: 'Tell us about your space and we call you back within 24 hours.'
  }, {
    number: '2',
    icon: <ClipboardList className="w-8 h-8" data-id="element-99" />,
    title: 'We Build Your Plan',
    description: 'We confirm scope, schedule, and a clear flat price. No surprises.'
  }, {
    number: '3',
    icon: <Sparkles className="w-8 h-8" data-id="element-100" />,
    title: 'Come Home to Clean',
    description: 'Our bilingual team shows up on time and leaves it spotless.'
  }];
  return <section className="py-20 md:py-28 bg-[#FBFCFB]" data-id="element-101">
      <div className="container mx-auto px-4" data-id="element-102">
        <div className="text-center max-w-2xl mx-auto mb-20" data-id="element-103">
          <span className="text-brand-green font-semibold tracking-wider uppercase text-sm mb-3 block" data-id="element-104">
            Simple and Easy
          </span>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-brand-navy" data-id="element-105">
            How It Works
          </h2>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-106">
          {/* Connecting Line (Desktop) */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-0.5 bg-gray-200" data-id="element-107" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 relative" data-id="element-108">
            {steps.map((step, index) => <div key={index} className="relative flex flex-col items-center text-center" data-id="element-109">
                {/* Mobile connecting line */}
                {index !== steps.length - 1 && <div className="md:hidden absolute top-24 bottom-[-3rem] left-1/2 w-0.5 bg-gray-200 -translate-x-1/2 z-0" data-id="element-110" />}

                <div className="w-24 h-24 rounded-full bg-white shadow-lg border border-gray-100 flex items-center justify-center relative z-10 mb-8 text-brand-navy" data-id="element-111">
                  {step.icon}
                  <div className="absolute -top-2 -right-2 w-8 h-8 rounded-full brand-gradient text-white flex items-center justify-center font-bold text-sm border-2 border-white" data-id="element-112">
                    {step.number}
                  </div>
                </div>

                <h3 className="text-xl font-heading font-bold text-gray-900 mb-4" data-id="element-113">
                  {step.title}
                </h3>
                <p className="text-gray-600 font-body leading-relaxed max-w-xs" data-id="element-114">
                  {step.description}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}